<template>
	<div class="customers">
		<CDataTable
			title="Customers"
			:loading="loading"
			:items="formattedCustumers"
			:options="$cusOptions"
			:headers="headers"
			@delete="initDelete"
			@update="initUpdate"
			@options="onChangeOptions"
			roleColor="#9575cd"
		/>

		<CreateCustomer :onCreate="handleCreate" v-model="createDialog" />

		<CreateCustomer
			update
			:data="update.data"
			:loading="update.loading"
			:onUpdate="handleUpdate"
			v-model="update.dialog"
		/>

		<DConfirm
			title="Are you sure to delete?"
			text="Once you delete, this action can't be undone"
			v-model="delet.dialog"
			:loading="delet.loading"
			@yes="handleDelete"
		/>

		<Fab @click="createDialog = true" />
	</div>
</template>

<script>
import moment from 'moment'
import * as api from '../api/api'
import Fab from '@/components/Fab'
import CDataTable from '@/components/CDataTable'
import CreateCustomer from '@/components/create/CreateCustomer'
import { mapActions, mapGetters } from 'vuex'
export default {
	name: 'Customers',
	components: {
		Fab,
		CDataTable,
		CreateCustomer
	},
	data: () => ({
		loading: false,
		createDialog: false,
		createConfirmDialog: false,
		delet: {
			dialog: false,
			loading: false,
			userId: null,
		},
		update: {
			dialog: false,
			loading: false,
			data: null
		},
		headers: [
			{ text: 'Full Name', value: 'fullName' },
			{ text: 'Role', value: 'role' },
			{ text: 'Phone Number', value: 'contact.phone' },
			{ text: 'Region', value: 'address.region' },
			{ text: 'City', value: 'address.city' },
			{ text: 'Area', value: 'address.area' },
			{ text: 'Address', value: 'address.address' },
			{ text: 'Updated', value: 'updatedAt' },
			{ text: 'Actions', value: 'actions' },
		]
	}),
	created() {
		//!this.$customers.length &&
		this.getCustomers()
	},
	computed: {
		...mapGetters('Customers', ['$customers', '$cusOptions']),
		formattedCustumers() {
			return this.$customers.map(customer => ({
				...customer,
				updatedAt: this.$hp.howAgo(customer.updatedAt)
			}))
		}
	},
	methods: {
		...mapActions('Customers', ['fetchCustomers']),
		resetDelete() {
			this.delet = {
				dialog: false,
				loading: false,
				userId: null
			}
		},
		resetUpdate() {
			this.update = {
				dialog: false,
				loading: false,
				data: null
			}
		},
		initUpdate(customer) {
			this.update = {
				...this.update,
				dialog: true,
				data: customer
			}
		},
		initDelete(id) {
			this.delet = {
				...this.delet,
				userId: id,
				dialog: true
			}
		},
		onChangeOptions({ total, page, itemsPerPage }) {
			this.getCustomers({
				page: page, limit: itemsPerPage === 'ALL'
					? total
					: itemsPerPage
			})
		},
		async handleDelete() {
			this.delet.loading = true
			let { err, res } = await api.deleteProfile(this.delet.userId)
			if (err) return
			this.resetDelete()
			await this.getCustomers()
		},
		async getCustomers(queries) {
			this.loading = true
			let { err, res } = await this.fetchCustomers(queries)
			if (err) return
			this.loading = false
		},
		async handleUpdate(uCus) {
			this.update.loading = true
			let { err, res } = await api.updateProfile(uCus._id, uCus)
			if (err) {
				this.update.loading = false
				return { success: false }
			}
			this.resetUpdate()
			this.getCustomers()
			return { success: true }
		},
		async handleCreate(customer) {
			let { res, err } = await api.createCustomer({
				...customer, userId: this.$hp.userId('customer')
			})
			if (err) return
			this.getCustomers()
			return { success: true }
		}
	},
}
</script>
